import * as Cookies from "js-cookie";
import * as lottie from 'lottie-web';

export default {
  init() {
      if ($('#lottie').length > 0) {
          var dark = 'rgba(0,0,0,0.25)';
          var light = 'rgba(255,255,255,0.75)';
          var params = {
              container: document.getElementById('lottie'),
              renderer: 'svg',
              loop: true,
              autoplay: true,
              animationData: animationData,
              rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
          };

          var anim;
          anim = lottie.loadAnimation(params);
          anim.addEventListener('DOMLoaded', function(e) {
                var $hero = $('.hero');
                if ($hero.hasClass('hero--check')) {
                    if ($hero.hasClass('hero--top--dark')) {
                        $('#__lottie_element_7').find('stop').attr('stop-color', dark);
                    } else {
                        $('#__lottie_element_7').find('stop').attr('stop-color', light);
                    }
                    if ($hero.hasClass('hero--bottom--dark')) {
                        $('#__lottie_element_13').find('stop').attr('stop-color', dark);
                    } else {
                        $('#__lottie_element_13').find('stop').attr('stop-color', light);
                    }
                }

                if ($hero.hasClass('hero--wave')) {
                    if ($hero.hasClass('hero--top--dark')) {
                        $('#__lottie_element_6').find('stop').attr('stop-color', dark);
                    } else {
                        $('#__lottie_element_6').find('stop').attr('stop-color', light);
                    }
                    if ($hero.hasClass('hero--bottom--dark')) {
                        $('#__lottie_element_12').find('stop').attr('stop-color', dark);
                    } else {
                        $('#__lottie_element_12').find('stop').attr('stop-color', light);
                    }
                }


          });
      }

    // JavaScript to be fired on all pages
      $('.image-carousel').each(function() {
        $(this).find('.image-carousel_items').slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            appendDots: $(this).find('.image-carousel_nav'),
            appendArrows: $(this).find('.image-carousel_nav'),
        });
      });

      $('.section--case_study.section--standard-carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 5,
              centerMode: true,
              variableWidth: true,
              appendDots: $(this).find('.case_study-carousel_nav'),
              appendArrows: $(this).find('.case_study-carousel_nav'),
          });
      });

      $('.section--logo_carousel').each(function() {
          $(this).find('.logo-carousel_items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 5,
              centerMode: true,
              variableWidth: true,
              appendDots: $(this).find('.logo-carousel_nav'),
              appendArrows: $(this).find('.logo-carousel_nav'),
          });
      });

      $('.section--case_study.section--image-carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 2,
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1,
                      },
                  },
              ],
              appendDots: $(this).find('.case_study-carousel_nav'),
              appendArrows: $(this).find('.case_study-carousel_nav'),
          });
      });

      $('.section--testimonial.section--standard-carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 3,
              centerMode: true,
              variableWidth: true,
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          infinite: true,
                          slidesToShow: 1,
                      },
                  },
              ],
              appendDots: $(this).find('.carousel_nav'),
              appendArrows: $(this).find('.carousel_nav'),
          });
      });

      $('.section--testimonial.section--image-carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              appendDots: $(this).find('.carousel_nav'),
              appendArrows: $(this).find('.carousel_nav'),
          });
      });

      $('.section--knowledge_base.section--carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 3,
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1,
                      },
                  },
              ],
              appendDots: $(this).find('.carousel_nav'),
              appendArrows: $(this).find('.carousel_nav'),
          });
      });

      $('.section--product.section--carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 3,
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1,
                      },
                  },
              ],
              appendDots: $(this).find('.carousel_nav'),
              appendArrows: $(this).find('.carousel_nav'),
          });
      });

      $('.section--news.section--carousel').each(function() {
          $(this).find('.carousel__items').slick({
              dots: true,
              arrows: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 3,
              centerMode: true,
              variableWidth: true,
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 2,
                          centerMode: false,
                          variableWidth: false,
                      },
                  },
              ],
              appendDots: $(this).find('.carousel_nav'),
              appendArrows: $(this).find('.carousel_nav'),
          });
      });

      $('.hero--large-text-carousel, .hero--large-icon-carousel, .hero--large-button-carousel').each(function() {
          var $slider = $(this).find('.width_wrapper');
          $slider.slick({
              arrows: false,
              dots: true,
              infinite: true,
              slidesToScroll: 1,
              slidesToShow: 1,
              autoplay: $slider.data('scroll'),
              autoplaySpeed: $slider.data('scroll-speed'),
              speed: $slider.data('transition-time'),
              fade: true,
              cssEase: 'linear',
          });
      });

      $('.hero--large-text-carousel .width_wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          processSlideColourTransition(currentSlide, nextSlide);
      });

      $('.hero--large-icon-carousel .width_wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          processSlideColourTransition(currentSlide, nextSlide);
      });

      $('.hero--large-button-carousel .width_wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          processSlideColourTransition(currentSlide, nextSlide);
      });

      function processSlideColourTransition(currentSlide, nextSlide)
      {
          var $currentSlide = $('.hero .hero_item[data-slick-index="'+ currentSlide +'"]');
          var $nextSlide = $('.hero .hero_item[data-slick-index="'+ nextSlide +'"]');

          var colourToRemove = $currentSlide.data('colour');
          if ($nextSlide.data('colour') == 'bg--inherit') {
              var colourToAdd = $('.hero .width_wrapper').data('start-colour');
          } else {
              var colourToAdd = $nextSlide.data('colour');
          }

          $('.hero').removeClass(colourToRemove).addClass(colourToAdd);
      }

      if ($('body').innerWidth() < 1024) {
          $('.section--grid.mobile-carousel').each(function () {
              $(this).find('.width_wrapper').slick({
                  dots: true,
                  arrows: true,
                  infinite: true,
                  slidesToScroll: 1,
                  slidesToShow: 1,
                  appendDots: $(this).find('.carousel_nav'),
                  appendArrows: $(this).find('.carousel_nav'),
              });
          });
      }



      /** Accordion **/
      $(document).on("click", ".accordion_container button", function (e) {
          e.preventDefault();
          var $button = $(this);
          var $parent = $(this).parent();
          var $panel = $("#" + $(this).attr("aria-controls"));
          if ($button.attr("aria-expanded") === "true") {
              $button.attr("aria-expanded", false);
              $panel.attr("aria-hidden", true);
          } else {
              $parent.find("button").each(function () {
                  $(this).attr("aria-expanded", false);
                  $("#" + $(this).attr("aria-controls")).attr("aria-hidden", true);
              });
              $button.attr("aria-expanded", true);
              $panel.attr("aria-hidden", false);
          }
      });

      $(document).on('click', '[data-js=toggle-grid]', function() {
          $('.grid_overlay').toggleClass('visible');
      });

      $(document).on('click', 'a[href*="#"]:not([href="#"])', function() {
          if ($(this).parent().hasClass('menu-item-has-children')) { return; }
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
              if (target.length) {
                  scrollToElement(target);

                  return false;
              }
          }
      });
      function scrollToElement(element) {
          var position = element.offset().top;

          if (element.attr('id') == 'top') {
              position = 0;
          }

          $('html, body').animate({
              scrollTop: position,
          }, 1000);
      }

      function scrollToElementOffset(element, offset) {
          var position = element.offset().top;

          position -= offset;

          $('html, body').animate({
              scrollTop: position,
          }, 1000);
      }

      $(document).on('click', '[data-video]', function(e) {
          e.preventDefault();

          $('.popover_underlay').remove();
//<iframe width="560" height="315" src="https://www.youtube.com/embed/ScMzIvxBSi4"
// frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          let src = $(this).attr('data-video');

          var html = '<div class="popover_underlay"><div class="popover popover--video">';
          html += '<button class="popover_close" data-js="popover-close">Close</button>';
          html += '<div class="popover_content"><div class="oembed_wrapper">';
          html += '<iframe src="'+ src + '" frameborder="0" allowfullscreen>';
          html += '</div></div></div></div>';

          $('body').append(html);

          $('html').addClass('overlay_loaded');
          $('.popover_underlay').fadeIn('fast', function () {
              $(this).addClass('visible');
          });
      });

      $(document).on('click', '.modal_underlay', function(e) {
          e.preventDefault();
          $('.modal_underlay').removeClass('visible');

          setTimeout(function() {
              $('.modal_underlay').remove();
          }, 250);
      });

      $(document).on('click', '.popover_underlay', function(e) {
          if ($('body').hasClass('single-modals')) {
              return;
          }

          if ($(e.target).closest('.popover').length === 0) {
              $('html').removeClass('overlay_loaded');
              $('.popover_underlay').removeClass('visible');

              setTimeout(function () {
                  $('.popover_underlay').remove();
              }, 250);
          }
      });

      $(document).on('click', '[data-js=popover-close]', function(e) {
          e.preventDefault();

          if ($('body').hasClass('single-modals')) {
              return;
          }

          $('html').removeClass('overlay_loaded');
          $('.popover_underlay').removeClass('visible');

          setTimeout(function () {
              $('.popover_underlay').remove();
          }, 250);
      });

      $(document).on('change', 'select[name="im"]', function(e) {
          // reset options
          $('select[name="looking_for"]').html('');
          var type = $(this).val();
          var optionsHtml = '';

          for (var i = 0; i < director_options.length; i++) {
              if (type == director_options[i].type) {
                  optionsHtml += '<option value="'+ director_options[i].looking_for +'">'+ director_options[i].looking_for +'</option>';
              }
          }

          $('select[name="looking_for"]').html(optionsHtml);
      });

      $(document).on('click', '[data-js=page-director]', function(e) {
          e.preventDefault();

          var type = $(this).parent().find('select[name="im"]').val();
          var looking = $(this).parent().find('select[name="looking_for"]').val();

          for (var i = 0; i < director_options.length; i++) {
              if (type == director_options[i].type && looking == director_options[i].looking_for) {
                  window.location.href = director_options[i].page;
              }
          }
      });

      $(document).on('click', 'button[data-js=easter-egg]', function(e) {
          e.preventDefault();

          $.get('easter-egg.html', function(response) {
              var html = '<div class="popover_underlay"><div class="popover popover--frog">';
              html += '<button class="popover_close" data-js="popover-close">Close</button>';
              html += '<div class="popover_content">';
              html += response;
              html += '</div></div></div>';

              $('body').append(html);

              $('html').addClass('overlay_loaded');
              $('.popover_underlay').fadeIn('fast', function () {
                  $(this).addClass('visible');
              });
          });
      });

      $(document).on('focusin', '.gform_wrapper input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=image]):not([type=file]), .gform_wrapper textarea', function() {
          $(this).parent().parent().addClass('form_group--focused');
      });

      $(document).on('focusout', '.gform_wrapper input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=image]):not([type=file]), .gform_wrapper textarea', function() {
          if ($(this).val() != '' || $(this).attr('type') == 'url') {
              $(this).parent().parent().addClass('form_group--not-empty');
          } else {
              $(this).parent().parent().removeClass('form_group--not-empty');
          }
          $(this).parent().parent().removeClass('form_group--focused');
      });

      if ($('.gform_wrapper').length > 0) {
          $('.gform_wrapper select').parent().parent().addClass('form_group--not-empty');
          $('.gform_wrapper input[type=url], .gform_wrapper input[type=file]').parent().parent().addClass('form_group--not-empty');
          $('.gfield.type-radio, .gfield.type-checkbox, .gfield.type-list').addClass('form_group--not-empty');
      }

      $(document).bind('gform_post_render', function() {
          if (!$('html').hasClass('overlay_loaded')) {
              scrollToElementOffset($('.section--form'), 150);
          }
          reinitForms();
      });
      $(document).bind('gform_page_loaded', function() {
          reinitForms();
      });

      function reinitForms() {
          if ($('.gform_wrapper').length > 0) {
              $('.gform_wrapper select').parent().parent().addClass('form_group--not-empty');
          }

          var $inputs = $('.gform_wrapper input:not([type=radio]):not([type=checkbox]):not([type=submit]):not([type=button]):not([type=image]):not([type=file]), .gform_wrapper textarea');
          $inputs.each(function() {
              if ($(this).val() != '' || $(this).attr('type') == 'url') {
                  $(this).parent().parent().addClass('form_group--not-empty');
              }
          });
      }

      $(document).on('click', '[data-js=toggle-search]', function(e) {
        e.preventDefault();

        if ($('body').hasClass('search')) {
            scrollToElementOffset($('.search_block'), 300);
        } else {
            $('.search_block').slideToggle();
        }
      });

      $(document).on('click', '[data-js=menu-toggle]', function(e) {
          e.preventDefault();

          if ($('body').hasClass('menu-toggled')) {
              $('li.has-sub-menu.active').removeClass('active');
              $('.menu_back').removeClass('visible');
          }

          $('html').toggleClass('mobile_menu_open');
          $('body').toggleClass('menu-toggled');
          $('.nav-primary').fadeToggle();
      });

      $(document).on('click', '.main__menu > li.has-sub-menu > a', function(e) {
          if ($('body').innerWidth() <= 1279) {
              e.preventDefault();

              $('.menu_back').addClass('visible');
              $(this).parent().addClass('active');
          }
      });

      $(document).on('click', '[data-js=menu-back]', function(e) {
          e.preventDefault();

          $('li.has-sub-menu.active').removeClass('active');
          $('.menu_back').removeClass('visible');
      });

      if ($('body').innerWidth() > 1280) {
          $('.main__menu > li').hover(
              function() {

                  var $specialItem = $(this).find('.menu-item--special');
                  if ($specialItem.length > 0) {
                      var $subMenu = $(this).find('.sub-menu__wrapper');
                      var offset = 20,
                          specialItemHeight = $specialItem.height(),
                          menuWrapperHeight = $subMenu.height();

                          if ((menuWrapperHeight - offset) <= specialItemHeight) {
                              $subMenu.find('li.menu-item-has-children').css('height', specialItemHeight);
                          }
                  }

                  $(this).addClass('hovering');
              },
              function() {
                  $(this).removeClass('hovering');
              }
          )
      }

      $(document).on('change', 'select[name="fake_category"]', function(e) {
          var selected = $(this).find('option:selected').val();

          $('input[name="category"][value="'+ selected +'"]').prop('checked', true);
      });
  },
  finalize() {
      $(window).scroll(function() {
         if ($('body').innerWidth() <= 768) {
             if ($(this).scrollTop() > 100 && !$('body').hasClass('scrolled')) {
                $('body').addClass('scrolled');
             } else if ($(this).scrollTop() <= 100) {
                 $('body').removeClass('scrolled');
             }
         }
      });

      var modalCookie = Cookies.getJSON('popovers');

      setTimeout(function () {
          // potentially need to set a cookie to not show it again...
          if ($('.popover_underlay').length > 0) {
              var showModal = true, modalId = $('.popover_underlay').attr('data-modal');
              if (modalCookie !== undefined) {
                  if (modalCookie.indexOf(modalId) >= 0) {
                      showModal = false;
                  }
              }
              if (showModal) {
                  var $popover = $('.popover');

                  if ($popover.attr('data-modal-type') == 'timed') {
                      var timeDelay = parseInt($popover.attr('data-modal-delay')) * 1000;
                      setTimeout(function () {
                          $('html').addClass('overlay_loaded');
                          $('.popover_underlay').fadeIn('fast', function () {
                              $(this).addClass('visible');

                              if (modalCookie === undefined) {
                                  Cookies.set('popovers', [modalId]);
                              } else {
                                  modalCookie.push(modalId);
                                  Cookies.set('popovers', modalCookie);
                              }
                          });
                      }, timeDelay)
                  } else {
                      var position = parseInt($popover.attr('data-modal-position')), hasShown = false;

                      $(window).scroll(function (e) {
                          var scrollTop = $(window).scrollTop();
                          var docHeight = $(document).height();
                          var winHeight = $(window).height();
                          var scrollPercent = (scrollTop) / (docHeight - winHeight);
                          var scrollPercentRounded = Math.round(scrollPercent * 100);

                          if (scrollPercentRounded >= position && !hasShown) {
                              $('html').addClass('overlay_loaded');
                              $('.popover_underlay').fadeIn('fast', function () {
                                  $(this).addClass('visible');
                                  hasShown = true;

                                  if (modalCookie === undefined) {
                                      Cookies.set('popovers', [modalId]);
                                  } else {
                                      modalCookie.push(modalId);
                                      Cookies.set('popovers', modalCookie);
                                  }
                              });
                          }
                      });

                      // $(window).resize(function(){
                      //     repositionLabel();
                      // });
                  }
              }
          }
      }, 2000);

      $('.logo-carousel_item').matchHeight();
      $('.section--product.section--carousel .component').matchHeight();

      function equaliseHeights() {
          if ($('body').innerWidth() > 768) {

              $('.section--grid').each(function() {
                  var $grid = $(this), matchingElements = true, $components;

                  $grid.find('.column').each(function() {
                      var $column = $(this);
                      $components = $column.find('.component');

                      $components.each(function() {
                          var $component = $(this);

                          if (!$component.hasClass('icon-text')) {
                              matchingElements = false;
                          }
                      });
                  });

                  if (matchingElements) {
                      $grid.find('.component').matchHeight({byRow: false});
                  }
              });
          }
      }
      equaliseHeights();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js